import React from 'react';
import AchievementBadge from '../../../pages/user-profile-dashboard/components/AchievementBadge';
import AchievementFilterItem from './AchievementFilterItem';

const AchievementsSection = ({
  achievementFilters,
  achievementCategory,
  setAchievementCategory,
  unlockedBadges,
  lockedBadges,
}) => {
  return (
    <div className="space-y-6 md:space-y-8">
      <div className="mb-2 overflow-x-auto">
        <div className="flex items-center space-x-2 min-w-max">
          {(achievementFilters || []).map((f) => (
            <AchievementFilterItem
              key={f.id}
              filter={f}
              isActive={achievementCategory === f.id}
              onClick={() => setAchievementCategory(f.id)}
            />
          ))}
        </div>
      </div>

      <div>
        <h2 className="text-xl md:text-2xl lg:text-3xl font-heading font-bold text-foreground mb-4 md:mb-6">
          획득한 업적 ({(unlockedBadges || []).length})
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {(unlockedBadges || []).map((badge) => (
            <AchievementBadge key={badge?.id} badge={badge} />
          ))}
        </div>
      </div>

      <div>
        <h2 className="text-xl md:text-2xl lg:text-3xl font-heading font-bold text-foreground mb-4 md:mb-6">
          잠긴 업적 ({(lockedBadges || []).length})
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {(lockedBadges || []).map((badge) => (
            <AchievementBadge key={badge?.id} badge={badge} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default AchievementsSection;
